(() => {
  const reduit = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('agdw-choix-hero')) {
    customElements.define(
      'agdw-choix-hero',
      class extends HTMLElement {
        connectedCallback() {
          this.boutons = [...this.querySelectorAll('[data-agdw-choix]')];
          this.panneaux = [...this.querySelectorAll('[data-agdw-reco]')];
          this.boutons.forEach((bouton) => {
            bouton.addEventListener('click', () => this.choisir(bouton));
          });
        }

        choisir(bouton) {
          const deja = bouton.getAttribute('aria-pressed') === 'true';
          this.boutons.forEach((b) => b.setAttribute('aria-pressed', 'false'));
          this.panneaux.forEach((p) => {
            p.hidden = true;
          });
          if (deja) return;
          bouton.setAttribute('aria-pressed', 'true');
          const panneau = this.querySelector(`[data-agdw-reco="${bouton.dataset.agdwChoix}"]`);
          if (!panneau) return;
          panneau.hidden = false;
          panneau.querySelectorAll('.agdw-hero__vedette, .agdw-hero__secondaire').forEach((carte) => {
            carte.style.animation = 'none';
            void carte.offsetWidth;
            carte.style.animation = '';
          });
        }
      }
    );
  }

  if (!customElements.get('agdw-machine')) {
    customElements.define(
      'agdw-machine',
      class extends HTMLElement {
        connectedCallback() {
          this.mot = this.querySelector('.agdw-espace__mot');
          try {
            this.mots = JSON.parse(this.dataset.mots || '[]');
          } catch (e) {
            this.mots = [];
          }
          this.pause = Number(this.dataset.pause) || 2200;
          if (!this.mot || this.mots.length < 2 || reduit()) return;
          this.index = 0;
          this.longueur = this.mots[0].length;
          this.phase = 'pause';
          this.suivant();
        }

        disconnectedCallback() {
          clearTimeout(this.minuterie);
        }

        suivant() {
          const actuel = this.mots[this.index];
          let delai = 90;
          if (this.phase === 'pause') delai = this.pause;
          if (this.phase === 'efface') delai = 55;
          this.minuterie = setTimeout(() => {
            if (this.phase === 'pause') {
              this.phase = 'efface';
            } else if (this.phase === 'efface') {
              if (this.longueur > 0) {
                this.longueur -= 1;
              } else {
                this.index = (this.index + 1) % this.mots.length;
                this.phase = 'tape';
              }
            } else if (this.longueur < actuel.length) {
              this.longueur += 1;
            } else {
              this.phase = 'pause';
            }
            this.mot.textContent = this.mots[this.index].slice(0, this.longueur);
            this.suivant();
          }, delai);
        }
      }
    );
  }

  if (!customElements.get('agdw-eventail')) {
    customElements.define(
      'agdw-eventail',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.agdw-temoignages') || this;
          this.cartes = [...this.querySelectorAll('[data-agdw-carte]')];
          this.cibles = [...this.querySelectorAll('[data-agdw-cible]')];
          this.n = this.cartes.length;
          this.ecart = this.cartes.map((_, i) => ((i * 37) % 11) - 5);
          this.survol = -1;
          this.p = -1;
          this.mobile = window.matchMedia('(max-width: 899px)');
          this.cibles.forEach((cible, i) => {
            cible.addEventListener('mouseenter', () => {
              clearTimeout(this.tSortie);
              clearTimeout(this.tEntree);
              this.tEntree = setTimeout(() => this.ouvrir(i), 90);
            });
            cible.addEventListener('mouseleave', () => {
              clearTimeout(this.tEntree);
              clearTimeout(this.tSortie);
              this.tSortie = setTimeout(() => {
                if (this.survol === i) this.ouvrir(-1);
              }, 160);
            });
          });
          this.cartes.forEach((carte, i) => {
            carte.addEventListener('mouseenter', () => {
              if (this.survol !== i) return;
              clearTimeout(this.tSortie);
              clearTimeout(this.tEntree);
            });
            carte.addEventListener('mouseleave', () => {
              if (this.survol !== i) return;
              clearTimeout(this.tSortie);
              this.tSortie = setTimeout(() => {
                if (this.survol === i) this.ouvrir(-1);
              }, 160);
            });
            carte.addEventListener('click', (e) => {
              if (this.survol !== i || e.target.closest('a')) return;
              const cible = this.cibles[i];
              if (cible && cible.href) window.open(cible.href, cible.target || '_self', 'noopener');
            });
          });
          this.tick = () => {
            this.raf = requestAnimationFrame(this.tick);
            this.mesurer();
          };
          this.observateur = new IntersectionObserver((entrees) => {
            entrees.forEach((e) => {
              if (e.isIntersecting && !this.raf) this.tick();
              if (!e.isIntersecting && this.raf) {
                cancelAnimationFrame(this.raf);
                this.raf = null;
              }
            });
          });
          this.observateur.observe(this.section);
          this.mesurer(true);
        }

        disconnectedCallback() {
          if (this.raf) cancelAnimationFrame(this.raf);
          this.raf = null;
          if (this.observateur) this.observateur.disconnect();
          clearTimeout(this.tEntree);
          clearTimeout(this.tSortie);
        }

        ouvrir(i) {
          this.survol = i;
          this.dessiner();
        }

        mesurer(force) {
          if (this.mobile.matches) return;
          const r = this.section.getBoundingClientRect();
          const vh = window.innerHeight;
          const debut = vh * 0.55;
          const fin = Math.min(debut - 200, vh / 2 - r.height / 2 + vh * 0.1);
          const p = reduit() ? 1 : Math.max(0, Math.min(1, (debut - r.top) / (debut - fin || 1)));
          const aw = this.clientWidth || 1200;
          const ah = this.clientHeight || 500;
          if (force || Math.abs(p - this.p) > 0.003 || aw !== this.aw || ah !== this.ah) {
            this.p = p;
            this.aw = aw;
            this.ah = ah;
            this.dessiner();
          }
        }

        dessiner() {
          if (this.mobile.matches) return;
          const p = this.p < 0 ? 0 : this.p;
          const aw = this.aw || 1200;
          const ah = this.ah || 500;
          const parRang = Math.ceil(this.n / 2);
          const largeur = 280;
          const hauteur = 390;
          const ratio = 0.66;
          const k = Math.max(0.45, Math.min(1, (ah - 160) / (hauteur * (1 + ratio))));
          const decalageRang = hauteur * ratio * k;
          const etendue = Math.max(200, Math.min(1500, aw - 2 * ((largeur * k) / 2 + 50)));
          const pas = etendue / (Math.max(parRang, 1.5) - 0.5);
          const adoucir = (t) => 1 - Math.pow(1 - t, 3);
          const ouverte = p > 0.6 ? this.survol : -1;
          this.cartes.forEach((carte, i) => {
            const depart = (i / this.n) * 0.55;
            const local = adoucir(Math.max(0, Math.min(1, (p - depart) / 0.45)));
            const rang = i < parRang ? 0 : 1;
            const j = i % parRang;
            const paquetX = -etendue * 0.2;
            const finX = -etendue / 2 + j * pas + (rang * pas) / 2;
            const u = parRang > 1 ? (j - (parRang - 1) / 2) / ((parRang - 1) / 2) : 0;
            const finY = (rang ? decalageRang / 2 : -decalageRang / 2) + u * u * 16 * k;
            const paquetRot = -8 + this.ecart[i] * 0.4;
            const finRot = u * 8 + (rang ? 1.5 : -1.5) + this.ecart[i] * 0.3;
            const x = paquetX + (finX - paquetX) * local;
            const y = (finY * local) - Math.sin(local * Math.PI) * 18;
            const rot = paquetRot + (finRot - paquetRot) * local;
            const base = `translate(${x}px, ${y}px) rotate(${rot}deg) scale(${k})`;
            const estOuverte = ouverte === i;
            let transformation = base;
            if (estOuverte) {
              const moitie = (largeur * k) / 2;
              const fx = Math.max(-aw / 2 + moitie + 16, Math.min(aw / 2 - moitie - 16, x));
              transformation = `translate(${fx}px, 0px) rotate(0deg) scale(${k})`;
            }
            carte.style.transform = transformation;
            carte.style.zIndex = estOuverte ? 400 : i + 1;
            carte.classList.toggle('est-ouverte', estOuverte);
            if (this.cibles[i]) {
              this.cibles[i].style.transform = base;
              this.cibles[i].style.zIndex = 200 + i;
            }
          });
        }
      }
    );
  }
})();